module.exports = __webpack_public_path__ + "Pages-icon.e07c311262f0c2bfbe97.svg";


//////////////////
// WEBPACK FOOTER
// D:/TMB/TMB/MYTMB.UI/src/assets/plugins/calendar/fonts/pages-icon/Pages-icon.svg?-u69vo5
// module id = ../../../../../src/assets/plugins/calendar/fonts/pages-icon/Pages-icon.svg?-u69vo5
// module chunks = styles